import React, { useState } from 'react';
import { Box, Button, Flex, Image, Input, Text } from '@chakra-ui/react';
import MyDiv from './proofDeclarationCard.style';
import InvestmentIcon from "../../../../assets/images/InvestmentIcon.svg";
import { CustomToast } from '../../../../components';

const ProofDeclarationCard = () => {
  const [step, setStep] = useState(1);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const { addToast } = CustomToast();

  return (
    <MyDiv>
      <Box className="card">
        <Flex className="title-row">
          <Image src={InvestmentIcon} />
          <Box>
            <Text className="font-poppins text_xl text_medium">Proof of Investment Window</Text>
            {step === 3 && (
              <Text className="subtext">Window Open Till ({date}, {time})</Text>
            )}
          </Box>
        </Flex>

        {step === 1 && (
          <>
            <Button className="action-btn" onClick={() => setStep(2)}>Start Proof of Investment Window</Button>
          </>
        )}

        {step === 2 && (
          <>
            <Box className="content">
              <Flex className="input-row">
                <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                <Input type="time" value={time} onChange={(e) => setTime(e.target.value)} />
              </Flex>
            </Box>
            <Button
              className="action-btn"
              onClick={() => {
                if (date && time){
                  setStep(3);
                } else{
                  addToast({message:'Date and Time is reuired',status:'error'})
                }
              }}
            >
              Open Window
            </Button>
          </>
        )}

        {step === 3 && (
          <>
            <Box className="content" />
            <Button className="action-btn disabled-btn" >Window is Open</Button>
          </>
        )}
      </Box>
    </MyDiv>
  );
};


export default ProofDeclarationCard;
